export const messages = {
  en: {
    addStaff: {
      title: 'Add Staff',
      stepTitles: {
        branch: 'Select Branch',
        department: 'Select Department',
        staffInfo: 'Staff Information'
      },
      form: {
        username: 'Staff Name (2-10 characters)',
        sex: 'Gender',
        position: 'Position',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        photo: 'Photo',
        male: 'Male',
        female: 'Female',
        takePhoto: 'Take Photo',
        uploadPhoto: 'Upload Photo',
        relatedOrg: 'Related Organization'
      },
      buttons: {
        prev: 'Previous',
        next: 'Next',
        finish: 'Complete',
        selectOrg: 'Select Organization'
      },
      validations: {
        required: 'This field is required',
        usernameLength: 'Staff name must be 2-10 characters',
        phoneInvalid: 'Invalid phone number',
        addressLength: 'Address cannot exceed 200 characters'
      }
    }
  },
  zh: {
    addStaff: {
      title: '添加员工',
      stepTitles: {
        branch: '选择分公司',
        department: '选择部门',
        staffInfo: '员工信息'
      },
      form: {
        username: '员工名称(2-10位)',
        sex: '员工性别',
        position: '员工岗位',
        email: '员工邮箱',
        phone: '手机',
        address: '家庭住址',
        photo: '照片',
        male: '男',
        female: '女',
        takePhoto: '拍照',
        uploadPhoto: '上传照片',
        relatedOrg: '关联组织'
      },
      buttons: {
        prev: '上一步',
        next: '下一步',
        finish: '完成',
        selectOrg: '选择组织'
      },
      validations: {
        required: '此项为必填项',
        usernameLength: '员工名称长度必须在2位至10位',
        phoneInvalid: '联系方式不是有效手机',
        addressLength: '家庭住址不能超过200位'
      }
    }
  }
}